import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FindUser } from '../../../../find-user-page/find-user';
import { UserType } from '../../../../../api/types/user/user-type';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';

interface SelectProfessorsFilterDialogProps {
  visible: boolean;
  onHide: () => void;
  alreadySelectedProfessors: UserSummaryType[];
  onApprove: (selectedProfessors: UserSummaryType[]) => void;
}

const mergeUniqueById = (
  base: UserSummaryType[],
  incoming: UserSummaryType[],
): UserSummaryType[] => {
  const seen = new Set<number>();
  const merged: UserSummaryType[] = [];
  [...base, ...incoming].forEach((user) => {
    if (!seen.has(user.id)) {
      seen.add(user.id);
      merged.push(user);
    }
  });
  return merged;
};

export const SelectProfessorsFilterDialog: React.FC<
  SelectProfessorsFilterDialogProps
> = ({ visible, onHide, alreadySelectedProfessors, onApprove }) => {
  const [selectedProfessors, setSelectedProfessors] = useState<
    UserSummaryType[]
  >([]);

  useEffect(() => {
    if (visible) {
      setSelectedProfessors([]);
    }
  }, [visible]);

  const handleApprove = () => {
    const merged = mergeUniqueById(
      alreadySelectedProfessors,
      selectedProfessors,
    );
    onApprove(merged);
    onHide();
  };

  return (
    <Dialog
      header="הוספת מרצים"
      visible={visible}
      style={{
        height: '100vh',
        width: '800px',
        backgroundColor: 'white',
        padding: '8px',
        borderRadius: '8px',
      }}
      onHide={onHide}
    >
      <div style={{ marginTop: '20px' }}>
        <FindUser
          role={UserType.LECTURER}
          onChange={setSelectedProfessors}
          onApprove={() => {
            //
          }}
          displayApprove={false}
        />
        <div
          style={{
            marginTop: '8px',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
          }}
        >
          <Button
            style={{ height: '30px' }}
            label="ביטול"
            outlined={true}
            onClick={onHide}
          />
          <div style={{ marginRight: '8px' }} />
          <Button
            onClick={handleApprove}
            style={{ height: '30px' }}
            label="אישור"
            disabled={selectedProfessors.length === 0}
          />
        </div>
      </div>
    </Dialog>
  );
};
